export const LOAD_CART = "LOAD_CART";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const UPDATE_CART = "UPDATE_CART";
export const GET_SLOTS = "GET_SLOTS";
export const DELIVERY_DATE = "DELIVERY_DATE";
export const DELIVERY_TIME_SLOT = "DELIVERY_TIME_SLOT";

// Phase 2 (Relay) Cart Actions
export const LOAD_PHASE2_CART = "LOAD_PHASE2_CART";
export const ADD_PHASE2_PRODUCT = "ADD_PHASE2_PRODUCT";
export const REMOVE_PHASE2_PRODUCT = "REMOVE_PHASE2_PRODUCT";
export const UPDATE_PHASE2_CART = "UPDATE_PHASE2_CART";
export const CLEAR_PHASE2_CART = "CLEAR_PHASE2_CART";

// Cart Error Actions
export const CART_STORE_LIMITATION_ERROR = "CART_STORE_LIMITATION_ERROR";
export const CLEAR_CART_ERROR = "CLEAR_CART_ERROR";
